import { IIdentifiable } from '@/common/models/models'
import { DownloadCategory, IDownloadCategory } from '@/common/models/data/dashboard/downloads/download-category'

interface IDownload extends IIdentifiable {
    category_id: number
    name: string
    file: string

    download_url: string
    extension: string

    category: IDownloadCategory
}

class Download implements IDownload {
    id = 0
    category_id = 0
    name = ''
    file = ''
    download_url = ''
    extension = ''

    category = new DownloadCategory()

    downloadFile: File | null = null

    constructor (dto?: IDownload) {
        if (dto) {
            this.id = dto.id
            this.category_id = dto.category_id
            this.name = dto.name
            this.file = dto.file
            this.download_url = dto.download_url
            this.extension = dto.extension

            this.category = new DownloadCategory(dto.category)
        }
    }

    get icon (): string {
        switch (this.extension) {
            case 'pdf':
                return 'file-pdf'

            case 'zip':
            case 'rar':
            case '7z':
                return 'file-multiple'

            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                return 'file-image'

            case 'mpga':
            case 'mp4':
            case 'mpg':
                return 'file-video'

            case 'mp3':
            case 'wav':
                return 'file-music'

            case 'ai':
            case 'psd':
                return 'file-code'

            default:
                return 'file'
        }
    }
}

export {
    IDownload, Download
}
